import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export function Banner({ banner }) {
    if (!banner || !banner.visible || !banner.image)
        return null;
    const img = (_jsx("img", { src: banner.image, alt: "", className: "career-banner-image", loading: "lazy" }));
    const link = banner.link && banner.link.length > 0 ? banner.link : '';
    return (_jsx("section", { className: "career-banner", children: link ? (_jsx("a", { href: link, target: "_blank", rel: "noopener noreferrer", className: "career-banner-link", children: img })) : (img) }));
}
